import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { UsersActions } from '@actions/index'
import * as fromUsers from '@reducers/index'
import { Observable } from 'rxjs';
import { UserModel, UserRolesModel, SentInvitationModel, UserBusinessModel, RequestModel } from '@models/index';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersFacadeService {

  constructor(private store: Store<any>, public router: Router,) { }

  getUsers$(): Observable<UserBusinessModel[]> {
    return this.store.select(fromUsers.getUsers)
    // .pipe(
    //   map(users => users.map(user => ({ ...user, reseller: "John Doe Reviews" })))
    // );
  }

  getUserRoles$(): Observable<UserRolesModel[]> {
    return this.store.select(fromUsers.getUserRoles)
  }

  getUserError$(): Observable<string> {
    return this.store.select(fromUsers.getErrorUsers)
  }

  getUsersByQuery$(): Observable<UserModel[]> {
    return this.store.select(fromUsers.getUsersByQuery)
  }

  getUserSize$(): Observable<number> {
    return this.store.select(fromUsers.getUserSize)
  }

  getSentInvitations$(): Observable<SentInvitationModel[]> {
    return this.store.select(fromUsers.getSentInvitations)
  }

  getResentInvitations$(): Observable<boolean> {
    return this.store.select(fromUsers.getResentInvitation)
  }

  getSentInvitationStates$(): Observable<string[]> {
    return this.store.select(fromUsers.getSentInvitationStates)
  }

  searchUsersByBusiness(data: { page: number, size: number, businessId: string }) {
    const request: RequestModel = {
      params: `userBusiness/business?id=${data.businessId}&page=${data.page}&size=${data.size}`,
    }
    this.store.dispatch(UsersActions.searchUsersByBusiness({ request }))
  }
  searchUsersQueryByBusiness(data: { page: number, size: number, businessId: string, q: string }) {
    const request: RequestModel = {
      params: `userBusiness/business/autocomplete?id=${data.businessId}&page=${data.page}&size=${data.size}&query=${data.q}`,
    }
    this.store.dispatch(UsersActions.searchUsersByBusiness({ request }))
  }
  searchUsersByQueryByBusiness(data: { page: number, size: number, businessId: string, q: string }) {
    const request: RequestModel = {
      params: `userBusiness/business/autocomplete?id=${data.businessId}&page=${data.page}&size=${data.size}&query=${data.q}`,
    }
    this.store.dispatch(UsersActions.searchUsersByQueryByBusiness({ request }))
  }
  searchSentInvitations(businessId: string) {
    this.store.dispatch(UsersActions.searchSentInvitations({ businessId }));
  }

  searchUserRoles() {
    this.store.dispatch(UsersActions.searchUserRoles())
  }

  createSentInvitation(sentInvitation: SentInvitationModel) {
    this.store.dispatch(UsersActions.createSentInvitation({ sentInvitation }))
  }

  createSentInvitationToReseller(sentInvitation: SentInvitationModel) {
    const request: RequestModel = {
      params: `users/invitation/reseller`,
      payload: sentInvitation
    }
    this.store.dispatch(UsersActions.createSentInvitationToReseller({ request }))
  }

  searchUsersByQuery(searchUserQuery: string) {
    const request: RequestModel = {
      params: `users/autocomplete?query=${encodeURIComponent(searchUserQuery)}&page=0&size=10`,
    }
    this.store.dispatch(UsersActions.searchUsersByQuery({ request }))
  }

  addRoleToUserToBusiness(payload: { user: UserModel, role: UserRolesModel, businessId: string }) {
    this.store.dispatch(UsersActions.addRoleToUserToBusiness({ payload }))
  }

  addRoleToUserToReseller(payload: { userId: string, roleId: string, resellerId: string }) {
    const request: RequestModel = {
      params: `userReseller`,
      payload: payload
    }
    this.store.dispatch(UsersActions.addRoleToUserToReseller({ request }))
  }

  deleteUser(userId: string) {
    this.store.dispatch(UsersActions.deleteUser({ userId }))
  }

  deleteUserFromReseller(payload: { userId: string, resellerId: string, businessId: string }) {
    const request: RequestModel = {
      params: `userReseller/delete`,
      payload: payload
    }
    this.store.dispatch(UsersActions.deleteUserFromReseller({ request }))
  }

  resendSentInvitation(payload: { userId: string, resellerId: string, businessId: string }) {
    this.store.dispatch(UsersActions.resendSentInvitation({ payload }))
  }

  showSearchBar(): boolean {
    return this.router.isActive('/users/users?user=site-admin', true) || this.router.isActive('/users/users?user=reseller', true)
  }

  currentRouteActive(): string {
    return this.router.url
  }

  searchAllUsers(pages) {
    // this.store.dispatch(UsersActions.searchAllUsers({ pages }))
  }

  searchUsersByReseller(data: { page: number, size: number, resellerId: string }) {
    const request: RequestModel = {
      params: `resellers/users?id=${data.resellerId}&page=${data.page}&size=${data.size}`,
    }
    this.store.dispatch(UsersActions.searchUsersByReseller({ request }))
  }

  clearUsersList() {
    this.store.dispatch(UsersActions.clearUsersList())
  }

  setResentInviation(value: boolean) {
    this.store.dispatch(UsersActions.setResentInvitation({ value }))
  }
  editUser(user: UserModel) {
    const request: RequestModel = {
      params: `users/edit`,
      payload: user
    }
    this.store.dispatch(UsersActions.editUser({ request }))
  }
  saveUserPhoneNumber(payload: { userId: string, phoneNumber: string, isEnableReviewText: boolean }) {
    const request: RequestModel = {
      params: `users/phone`,
      payload
    }
    this.store.dispatch(UsersActions.saveUserPhoneNumber({ request }))
  }
  updateShowModalPhoneNumber(payload: { userId: string, isShowModal: boolean }) {
    const request: RequestModel = {
      params: `users/update-number-modal`,
      payload
    }
    this.store.dispatch(UsersActions.updateShowModalPhoneNumber({ request }))
  }
  updateRoleOnResellerView(payload: { userId: String, resellerId: String, name: string, lastName: string }) {
    const request: RequestModel = {
      params: `users/set-reseller-role`,
      payload: payload
    }
    this.store.dispatch(UsersActions.updateRoleOnResellerView({ request }))
  }
  updateRoleOnBusinessView(payload: { userId: String, resellerId: String, name: string, lastName: string, businessId: string }) {
    const request: RequestModel = {
      params: `users/set-reseller-role`,
      payload: payload
    }
    this.store.dispatch(UsersActions.updateRoleOnBusinessView({ request }))
  }
}
